// @flow

export type CompanySelfServiceStatus = {
  selfServiceEnabled: boolean,
}

const buildCompanySelfServiceStatus = (selfServiceEnabled: boolean = false): CompanySelfServiceStatus => {
  return {
    selfServiceEnabled
  }
}

export {
  buildCompanySelfServiceStatus
}



// WEBPACK FOOTER //
// ./src/types/company-self-service-status.js